import styled from "styled-components";
import { ContentContainerBase } from "../../common/components";

export const ContentContainer = styled(ContentContainerBase)`
  position: absolute;
  justify-content: center;
  margin-top: 60px;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.75);
  @media ${({ theme }) => theme.device.tablet} {
  }
`;

export const TicketQRCodeBackground = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${({ theme }) => theme.device.tablet} {
  }
`;

export const TicketWrapper = styled.div`
  width: 300px;
  height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
  background-color: #ffffff;
  border-radius: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    width: 500px;
    height: 900px;
  }
`;

export const TicketImgBox = styled.img`
  width: 300px;
  height: 300px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    width: 500px;
    height: 500px;
  }
`;

export const Ticket = styled.div`
  width: 300px;
  height: 200px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  gap: 10px;
  @media ${({ theme }) => theme.device.tablet} {
    width: 500px;
    height: 400px;
    gap: 30px;
  }
`;

export const QRTitleText = styled.div`
  font-family: "Regular";
  text-align: center;
  margin-top: 15px;
  @media ${({ theme }) => theme.device.tablet} {
  }
`;

export const QRCodeWrppaer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  @media ${({ theme }) => theme.device.tablet} {
    gap: 10px;
  }
`;
